import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Trans } from "react-i18next";
import { Icon } from "./Icon";
import { SidebarData } from "./SidebarData";

const Sidebar = ({ closeSidebar }) => {
  const { pathname } = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const menuRef = useRef(null);

  const handleToggle = (id, hasSubNav) => {
    if (hasSubNav) {
      setOpenMenu((prev) => (prev === id ? null : id));
    } else {
      setOpenMenu(null);
    }
  };

  const handleClickOnSubNav = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="sidebar">
      <nav className="left-menu">
        <ul className="main-nav">
          {SidebarData.map((item) => {
            const isActive =
              pathname === item.path ||
              item.subNav?.some((sub) => pathname === sub.path);
            const isOpen = openMenu === item.id;

            return (
              <>
                <li
                  key={item.id}
                  className={`po-r pointer ${isActive ? "active" : ""}`}
                  onClick={() => handleToggle(item.id, Boolean(item.subNav))}
                >
                  <div className="menu-title">
                    <Link to={item.path}>
                      <Trans i18nKey={item.title} />
                    </Link>

                    {item.subNav && (
                      <i className="icn pointer">
                        <Icon name={isOpen ? "chevron--up" : "chevron--down"} />
                      </i>
                    )}
                  </div>

                  {item.subNav && isOpen && (
                    <ul className="menu-list open">
                      {item.subNav.map((sub, index) => (
                        <li
                          key={index}
                          className={
                            pathname === sub.path ? "active-subitem" : ""
                          }
                          onClick={handleClickOnSubNav}
                        >
                          <Link to={sub.path}>
                            <Trans i18nKey={sub.Subtitle} />
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
                <div class="line"></div>
              </>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
